.bulkSelectionRow {
	display: flex;
}